import React, { useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'

export default function InputHidden({ name, value }) {
  const [input] = useStoreState(state => [state.form.getByName(name)])
  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])

  useEffect(() => {
    setInputValue({ name, value })
    return () => {}
  }, [name, setInputValue, value])

  return (
    <input
      type="hidden"
      id={`hidden-${name}`}
      name={name}
      value={value}
    />
  )
}
